import Winter2023 from './Winter2023';

export default Winter2023;